import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MapPin, MessageCircle } from 'lucide-react';

const ContactUs = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 text-white">
            {/* Header */}
            <header className="fixed top-0 w-full z-50 bg-gray-900/90 backdrop-blur-md border-b border-gray-700/50">
                <div className="max-w-7xl mx-auto px-4 py-3 sm:py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center space-x-2">
                        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center">
                            <span className="text-white font-bold text-sm sm:text-lg">G</span>
                        </div>
                        <span className="text-lg sm:text-2xl font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
                            AVENTE MATNITCH
                        </span>
                    </Link>

                    <Link
                        to="/"
                        className="flex items-center space-x-2 bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded-full transition-colors duration-300"
                    >
                        <ArrowLeft size={16} />
                        <span className="text-sm">Back to Home</span>
                    </Link>
                </div>
            </header>

            {/* Main Content */}
            <div className="pt-24 pb-16 px-4">
                <div className="max-w-4xl mx-auto">

                    {/* Hero Section */}
                    <div className="text-center mb-12">
                        <div className="flex items-center justify-center space-x-4 mb-6">
                            <div className="w-16 h-16 bg-gradient-to-r from-pink-600 to-purple-600 rounded-2xl flex items-center justify-center">
                                <MessageCircle className="text-white" size={32} />
                            </div>
                        </div>
                        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">
                            Contact Us
                        </h1>
                        <p className="text-xl text-gray-300 mb-6">
                            We'd love to hear from you. Please get in touch with our team.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        {/* Contact Info */}
                        <div className="bg-gray-800/50 backdrop-blur-md p-6 sm:p-8 rounded-2xl border border-gray-700/50">
                            <h2 className="text-2xl font-bold text-pink-400 mb-6">Get In Touch</h2>

                            <div className="space-y-6">
                                <div className="flex items-start space-x-4">
                                    <div className="w-10 h-10 bg-gradient-to-r from-pink-600 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <Mail className="text-white" size={20} />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">Email Us</h3>
                                        <p className="text-gray-400 mb-2">For general queries and support:</p>
                                        <a href="mailto:mail@aventematnitch.in" className="text-pink-400 hover:text-pink-300 font-medium break-all block mb-1">
                                            mail@aventematnitch.in
                                        </a>
                                        <a href="mailto:aventematnitch@gmail.com" className="text-pink-400 hover:text-pink-300 font-medium break-all block">
                                            aventematnitch@gmail.com
                                        </a>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-4">
                                    <div className="w-10 h-10 bg-gradient-to-r from-pink-600 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                                        <MapPin className="text-white" size={20} />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-lg mb-1">Our Location</h3>
                                        <div className="text-gray-400">
                                            <p>Dungus poonch, ward no 5.</p>
                                            <p>Jammu and Kashmir, India</p>
                                            <p>185101</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Support Message */}
                        <div className="bg-gradient-to-r from-pink-600/20 to-purple-600/20 backdrop-blur-md p-6 sm:p-8 rounded-2xl border border-gray-700/50 flex flex-col justify-center text-center">
                            <MessageCircle className="text-pink-400 mx-auto mb-4" size={32} />
                            <h3 className="text-2xl font-bold mb-4">Need Quick Help?</h3>
                            <p className="text-gray-300 mb-6">
                                Our support team is available 24/7 for all our products including <span className="text-pink-400 font-medium">Gupshup</span>, <span className="text-pink-400 font-medium">Dakhla</span>, <span className="text-pink-400 font-medium">Guplup</span>, and <span className="text-pink-400 font-medium">LiveGup</span>. We aim to respond to all inquiries within 24 hours.
                            </p>
                            <a
                                href="mailto:mail@aventematnitch.in"
                                className="bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 px-6 py-3 rounded-full font-semibold transform hover:scale-105 transition-all duration-300 inline-block mx-auto"
                            >
                                Send an Email
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
